import React, { Component } from 'react';
import AppUtils from '../apputils';
import Logo from '../assets/images/kinship-logo.svg';
import Home_svg from '../assets/images/home_black.svg';
import Class_svg from '../assets/images/Classes.png';
import Games_svg from '../assets/images/games.svg';
import Calendar from '../assets/images/schedule_black_24dp.svg';
import Cross from '../assets/images/shape-cross.svg';
import '../assets/styling/navbar.css';
//import $ from 'jquery';
import { PnkConnect } from '../pnk-react/pnk-miniredux';


class sidebar extends Component {
    constructor(props) {
        super(props)


        this.sideHref = ['/home', '/upcoming-events', '/travel', '/classes', '/all-games'];
        this.sideId = ['#home', '#events', '#travel', '#classes', '#games'];
    }

    HandleRouting = (route) => {
        AppUtils.HandlePageClick(this.props.componentprops, route)
        this.props.componentprops.RemoveClass();
    }

    componentDidMount = () => {

       // alert(this.props.componentprops.siderbarActive)

        //     for(var i = 0 ; i<this.sideHref.length; i++){
        //         if(window.location.href.includes(i))
        //         {}
        //        // $(this.sideId[i]).addClass("active")
        //     }
    }

    //   UNSAFE_componentWillReceiveProps = () => {
    //       alert('kkkkkkkkkkkk');
    //   }



    render() {
      //  alert('ggggg')
     // this.forceUpdate();
     
        // for(var i = 0 ; i<this.sideHref.length; i++){
        //     if(window.location.href.includes(i))
        //     alert('same')
        //     else
        //     alert('diff')
        //    // $(this.sideId[i]).addClass("active")
        // }


        return (
            <div>
                <div className="vertical-nav kinship-sidebar-main" class={this.props.sidebarActive} id="sidebar">
                    {//alert(this.props.componentprops.siderbarActive)}
                    }
                    <div className="mb-4">
                        <div className="media d-flex align-items-center sidebar-logo" onClick={() => this.HandleRouting('home')}>
                            <img src={Logo} alt='logo....' />
                        </div>
                        <div className="media d-flex align-items-center cross-div">
                            <img src={Cross} alt='logo....' onClick={this.props.componentprops.RemoveClass} />

                        </div>
                        <div className='sidebar-order-btn'>
                            <button className='btn' id="kkkkkk" onClick={() => this.HandleRouting('upcoming-sessions')}>Book Session</button>
                        </div>
                        <ul className="nav flex-column mb-0">
                            <li className="nav-item sidebar-list">
                                <a href='/home' className='nav-link sidebar-items '
                                    id="home"
                                    data-toggle="tab"
                                    role="tab"
                                    onClick={() => this.HandleRouting('home')}
                                >
                                    <img className="sidebar-icons" src={Home_svg} alt="loading..."/>
                                    Home
                                </a>

                            </li>
                            <li className="nav-item sidebar-list">
                                <a href='/upcoming-sessions' className='nav-link sidebar-items'
                                    id="upcoming-sessions"
                                    data-toggle="tab"
                                    role="tab"
                                    onClick={() => this.HandleRouting('upcoming-sessions')}
                                >
                                    <img className="sidebar-icons" src={Calendar} alt="loading..."/>
                                    Sessions
                                </a>

                            </li>
                            <li className="nav-item sidebar-list">
                                <a href='/events' className='nav-link sidebar-items'
                                    id="events"
                                    data-toggle="tab"
                                    role="tab"
                                   onClick={()=>this.HandleRouting('upcoming-events')}
                                >
                                    <img className="sidebar-icons" src={Class_svg} alt="loading..." />
                                    Events
                                </a>

                            </li>

                            <li className="nav-item sidebar-list">
                                <a href='/travel' className='nav-link sidebar-items'
                                    id="travel"
                                    data-toggle="tab"
                                    role="tab"
                                    onClick={() => this.HandleRouting('travel')}
                                >
                                    <i class="fa fa-plane fa-lg sidebar-icons" aria-hidden="true"></i>
                                    Travel
                                </a>

                            </li>
                            <li className="nav-item sidebar-list">
                                <a href='/all-games' className='nav-link sidebar-items'
                                    id="all-games"
                                    data-toggle="tab"
                                    role="tab"
                                    onClick={() => this.HandleRouting('all-games')}
                                >
                                    <img className="sidebar-icons" src={Games_svg} alt="loading..." />
                                    Games
                                </a>

                            </li>



                            <div className="sidebar-more-from-hank">
                                <p>MORE FROM KINSHIP</p>
                            </div>

                            <li className="nav-item sidebar-list">
                                <a href='#' className='nav-link sidebar-items'
                                    id="partner"
                                    data-toggle="tab"
                                    role="tab"
                                    onClick={() => this.HandleRouting('partner')}
                                >
                                    Partnerships
                                </a>

                            </li>
                            <li className="nav-item sidebar-list">
                                <a href='/login' className='nav-link sidebar-items'
                                    id="contact"
                                    data-toggle="tab"
                                    role="tab"
                                    onClick={() => this.HandleRouting('contact')}
                                >
                                    Contact Us
                                </a>

                            </li>
                            <li className="nav-item sidebar-list">
                                <a href='#' className='nav-link sidebar-items'
                                    id="home-tab"
                                    data-toggle="tab"
                                    role="tab"
                                    onClick={() => this.props.componentprops.ShowHowKinshipWorkModal()}
                                >
                                    About Kinship Living
                                </a>

                            </li>
                            {/*  <li className="nav-item sidebar-list">
                            <a href='#' className='nav-link sidebar-items'
                                id="home-tab"
                                data-toggle="tab"
                                role="tab"
                               // onClick={()=>this.props.componentprops.ShowFriendlyCallsModal()}
                            >
                                Friendly Calls
                            </a>
            </li>*/}
                            <li className="nav-item sidebar-list">

                                <a href='#' className='nav-link sidebar-items'
                                    id="refer-earn"
                                    data-toggle="tab"
                                    role="tab"
                                    onClick={() => this.HandleRouting('refer-earn')}

                                >
                                    Referrals & Credits
                                </a>
                            </li>
                        </ul>
                    </div>

                </div>


            </div>
        )
    }
}

export const SideBar = PnkConnect(sidebar, 'currentUrl');